import { Component, OnInit,Inject, ViewChild } from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog'
import { HttpClient } from '@angular/common/http'
import {DashboardService} from './../../dashboard.service'
import { UntypedFormControl, FormGroup, NgForm, Validators } from '@angular/forms';
import {Department} from './../../../models/department.model'
import { Observable, Subscription } from 'rxjs';
import { Position } from './../../../models/positon.model'
import { ActivatedRoute } from '@angular/router';
import { AdminLanguageService } from '../../services/admin-language-service/admin-language.service';
import { MatSnackBar } from '@angular/material/snack-bar';


@Component({
    selector: 'app-insert-dialog',
    templateUrl: './insert-dialog.component.html',
    styleUrls: ['./insert-dialog.component.scss'],
    standalone: false
})
export class InsertDialogComponent implements OnInit {
  nameControl = new UntypedFormControl('', [Validators.required]);
  id:string
  @ViewChild('insertForm') insertForm:NgForm
  labels;
  labelsSub: Subscription;
  err: boolean = false;
  constructor(public dialogRef: MatDialogRef<InsertDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
    private dashboardService:DashboardService,
    private router:ActivatedRoute,
    public adminLanguageService: AdminLanguageService, public snackBar: MatSnackBar
    ) { }

  ngOnInit(): void {
    this.err = false;
    console.log(this.data)
    this.getLang()
  }

  onNoClick(){
    this.dialogRef.close()
  }
  getLang(){
    this.labelsSub = this.adminLanguageService.labels$.subscribe((labels) => {
      this.labels = labels;
      })
  }
  onSubmit(){
    if(this.insertForm.value.name == ""){
       this.err = true
       this.snackBar.open(this.labels.lblAllfieldsError, 'OK', {
        verticalPosition: 'top',
        horizontalPosition: 'end',
        duration: 5000
      })
    }else{
    let data={
      name:this.insertForm.value.name,
      trainingId:this.data._id,
      order:this.data.order
    }
    console.log(data)
    this.dashboardService.insertSection(data).subscribe((response)=>{
      console.log(response)
      this.snackBar.open(this.labels.lblTrainingSectionAdded, 'OK', {
        verticalPosition: 'top',
        horizontalPosition: 'end',
        duration: 5000
      })
      this.dialogRef.close()
    })
    }
   }
}
